import { BaseService } from './base.service';
import { BoIdMapping } from '@/types/BoIdMapping';
import { TextResourceDTO } from '@/model/TextResourceDTO';
import { ImageResourceDTO } from '@/model/ImageResourceDTO';

export class ResourceService extends BaseService {
	async fetchTexts(pageUrl: string, boIdMappings: BoIdMapping[] = [], includeNullInstance: boolean = false) {
		return await this.fetch<TextResourceDTO[]>(`/api/resource/text/${pageUrl}`, {
			boIdMappings,
			includeNullInstance
		});
	}

	async fetchImages(blockId: number, key: string, boIdMapping: BoIdMapping = {}) {
		return await this.fetch<ImageResourceDTO[][]>(`/api/resource/image/${blockId}/${key}`, {
			boIdMapping
		});
	}
}
